import { z } from 'zod';
import { DecimalJSLikeSchema } from "../inputTypeSchemas/DecimalJsLikeSchema"
import { isValidDecimalInput } from "../inputTypeSchemas/isValidDecimalInput"
import { PersonInspectionsRoleSchema } from '../inputTypeSchemas/PersonInspectionsRoleSchema'

/////////////////////////////////////////
// PERSON SCHEMA
/////////////////////////////////////////

export const PersonSchema = z.object({
  inspections_role: PersonInspectionsRoleSchema,
  personId: z.number().int(),
  cityId: z.number().int(),
  personType: z.string(),
  guest: z.number().int(),
  firstName: z.string(),
  lastName: z.string(),
  streetNum: z.string(),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  phone: z.string().nullable(),
  altPhone: z.string(),
  email: z.string().nullable(),
  active: z.number().int(),
  notifyPreference: z.string(),
  emailType: z.string(),
  username: z.string(),
  password: z.string(),
  admin: z.bigint(),
  adminCommon: z.bigint(),
  adminCRM: z.bigint(),
  adminCE: z.bigint(),
  validateId: z.number().int(),
  company: z.string(),
  delegateId: z.number().int(),
  CEAccess: z.number().int(),
  departmentId: z.number().int(),
  deptAdmin: z.number().int(),
  title: z.string(),
  longitude: z.number().int(),
  latitude: z.number().int(),
  allRO: z.number().int(),
  phoneWhenClosed: z.number().int(),
  subscriptions: z.string(),
  personOptions: z.string(),
  hourlyRate: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'hourlyRate' must be a Decimal. Location: ['Models', 'Person']",  }),
  fbId: z.string(),
  password_digest: z.string().nullable(),
  reset_sent_at: z.coerce.date().nullable(),
  reset_token: z.string().nullable(),
  verified_at: z.coerce.date().nullable(),
  verification_sent_at: z.coerce.date().nullable(),
  verification_token: z.string().nullable(),
  crm_role: z.string().nullable(),
  super_admin: z.boolean().nullable(),
  ce_role: z.string().nullable(),
  ce_all_read_only: z.number().int().nullable(),
  communications_role: z.string().nullable(),
  permits_role: z.string().nullable(),
  in_office: z.boolean().nullable(),
  delegate_user_id: z.number().int().nullable(),
  external_id: z.string().nullable(),
  last_login_at: z.coerce.date().nullable(),
  person_sub_type: z.string().nullable(),
  license_number: z.string().nullable(),
  company_name: z.string().nullable(),
  home_address: z.string().nullable(),
  home_city: z.string().nullable(),
  home_state: z.string().nullable(),
  home_zip: z.string().nullable(),
  email_verified_at: z.coerce.date().nullable(),
  phone_verified_at: z.coerce.date().nullable(),
  last_web_access_at: z.coerce.date().nullable(),
  last_mobile_access_at: z.coerce.date().nullable(),
  address2: z.string().nullable(),
  home_address2: z.string().nullable(),
  created_at: z.coerce.date().nullable(),
  updated_at: z.coerce.date().nullable(),
  same_mail_and_physical_address: z.boolean().nullable(),
  rowTimestamp: z.coerce.date(),
  countryId: z.string(),
  homeCountryId: z.string(),
})

export type Person = z.infer<typeof PersonSchema>

export default PersonSchema;
